export interface QuickBooksExportableBillConstructor {
  id: number // selection key for stage/archive/unstage
  groupId: string // "Bill" column label
  vendorName: string
  submittedDate: Nullable<ISODateString>
  dueDate: Nullable<ISODateString>
  uuid: string // detail link /bills/requests/{uuid}
  stagedForExport: boolean
}

export class QuickBooksExportableBill {
  readonly id: number
  readonly groupId: string
  readonly vendorName: string
  readonly submittedDate: Nullable<Date>
  readonly dueDate: Nullable<Date>
  readonly uuid: string
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportableBillConstructor) {
    this.id = data.id
    this.groupId = data.groupId
    this.vendorName = data.vendorName
    this.submittedDate = data.submittedDate
      ? new Date(data.submittedDate)
      : null
    this.dueDate = data.dueDate ? new Date(data.dueDate) : null
    this.uuid = data.uuid
    this.stagedForExport = data.stagedForExport
  }
}
